import {css} from "@emotion/react";
import React from 'react';
import {Spacing} from "../../../../../Spacing";
//import {DownTriangle} from "./components/Triangle";
import {root, rootFullWidth, Td, TdFlex, Th, ThFlex, Tr} from "./styles";

export interface DataType {
    name: string;
    options?: {
        align?: "center" | "left" | "right";
    }
    values: React.ReactNode[];
}

export interface TableProps {
    data: DataType[];
    fullWidth?: boolean;
}


const alignToFlex = (x: NonNullable<DataType['options']>['align']) => {
    switch (x) {
        case "left":
            return "flex-start";
        case "right":
            return "flex-end";
    }
    return x;
}

export const Table: React.FC<TableProps> = ({
    data,
    fullWidth,
}) => {

    const getRows = () => {
        const rows = [];
        for (let i = 0; ; i++) {
            let hasRow = false;
            const row = data.map(cols => {
                const target = cols.values[i];
                hasRow = hasRow || i < cols.values.length;
                return target;
            });
            if (!hasRow) break;

            rows.push(
                <Tr key={i}>
                    {row.map((x, idx) =>
                        <Td key={idx}>
                            <TdFlex css={css({
                                alignItems: alignToFlex(data[idx].options?.align || "center"),
                            })}>{x}</TdFlex>
                        </Td>,
                    )}
                </Tr>,
            );
        }
        return rows;
    };

    return <table cellPadding={0} cellSpacing={0} css={[root, fullWidth && rootFullWidth]}>
        <thead>
        <Tr>
            {data.map((x, idx) =>
                <Th key={idx}>
                    <ThFlex css={css({
                        justifyContent: alignToFlex(data[idx].options?.align || "center"),
                    })}>{x.name}<Spacing w={1}/>
                    </ThFlex>
                </Th>,
            )}
        </Tr>
        </thead>
        <tbody>
        {getRows()}
        </tbody>
    </table>
};
